import React from 'react';
import icon1900 from '../assets/images/1_Intro/intro_choice_1900.png';
import icon1980 from '../assets/images/1_Intro/intro_choice_1980.png';

const OurChoice = () => {
    return (
        <div className="row" id="our-choice" style={{marginTop: '34px'}}>
            <div className="col-md-12">
                <h2>Our choice</h2>
                <p>New York has demonstrated throughout its history that investment in transit is the key to unlocking economic growth for the region&mdash;and that failure to do so has dire consequences. Now it's our turn to confront upcoming challenges and secure the future for the next generation.</p>
                <h3>We've been here before ...</h3>
                <div className="row">
                    <div className="col-md-6">
                        <img src={icon1900} style={{height: '260px'}} alt="" aria-hidden="true"  />
                        <h4>1900-1970s</h4>
                        <p>After transit investments more than 100 years ago made modern New York possible, unleashing more than two generations of growth, by the 1970s the system had been allowed to fall into disrepair. As the transit system deteriorated, the city's population and economy plummeted with it, pushing New York to the brink of bankruptcy.</p>
                    </div>
                    <div className="col-md-6">
                        <img src={icon1980} style={{height: '260px'}} alt="" aria-hidden="true" />
                        <h4>1980-2000s</h4>
                        <p>In the 1980s, a historic investment reinvigorated the system&mdash;and New York's fortunes revived with it. More recently, we nearly repeated the cycle as disinvestment in the early 2000s brought us to the "Summer of Hell" in 2017 when, once again, our transit infrastructure began to break down.</p>

                    </div>
                        
                </div>
                <p>
                    <a className="plus-sign blue" href="history">Revisit our history</a>
                </p>
            </div>
        </div>
    );
};

export default OurChoice;